import getComponents from './getComponents'
import logsBeautify from './logsBeautify'

export default function () {
  if (process.env.NODE_ENV != 'production') {
    // para não ler o objeto inteiro
    const ramificacao = {
      limite: 500,
      atual: 1
    }

    const obj = {}
    const app = window.app

    obj.components = getComponents(app, ramificacao, true)
    obj.route = app.$route

    // obj.components = components.filter(component => componentsDefault.indexOf(component.name) == -1)
    // obj.componentsDefault = components.filter(component => componentsDefault.indexOf(component.name) != -1)

    logsBeautify(obj, true)
    return 'Sofia :)'
  } else {
    return 'Ação não permitida!'
  }
}
